import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { Data, Model, Utils } from '@singularsystems/neo-core';
import { AppService, Types } from '../../App/Services/AppService';
import EventMappingSearchCriteria from '../EventMapping/Models/EventMappingSearchCriteria';
import EventSearchCriteria from '../EventMapping/Models/EventSearchCriteria';
import StaticEventLookup from '../EventMapping/Models/StaticEventSearchModal/StaticEventLookup';
import EventMappingLookup from '../EventMapping/Models/EventMappingLookup';
import CommandResult from '../../Common/Models/CommandResult';
import EventMappingUpdate from '../EventMapping/Models/EventMappingUpdate';

export interface IEventMappingApiClient {
    getPagedEventMappings(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<EventMappingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<EventMappingLookup>>>;
    getStaticEvents(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<EventSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<StaticEventLookup>>>;
    updateEventMapping(payload: Model.PartialPlainObject<EventMappingUpdate>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class EventMappingApiClient extends Data.ApiClientBase implements IEventMappingApiClient {
    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/EventMapping`)
    }

    public getPagedEventMappings(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<EventMappingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<EventMappingLookup>>> {
        return this.axios.get(`${this.apiPath}/GetEventMappingList?${Utils.getQueryString(payload)}`);
    }

    public getStaticEvents(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<EventSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<StaticEventLookup>>> {
        return this.axios.get(`${this.apiPath}/GetStaticEventList?${Utils.getQueryString(payload)}`);
    }

    public updateEventMapping(payload: Model.PartialPlainObject<EventMappingUpdate>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.patch(`${this.apiPath}/UpdateEventMappings`, payload);
    }
}